<div #input class="container">
  <div class="chip-value-container">
    @for (resource of resources; track resource) {
      <div class="chip-value" (click)="click(resource); $event.stopPropagation()">
        {{ resource.value }}
      </div>
    }
  </div>
</div>
